import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface PageHeroProps {
    id?: string
    eyebrow: string
    title: ReactNode
    description?: ReactNode
    children?: ReactNode
    className?: string
}

export const PageHero: FC<PageHeroProps> = ({
    id = 'page-hero',
    eyebrow,
    title,
    description,
    children,
    className
}): ReactNode => {
    return (
        <section id={id} className={cn('relative overflow-hidden border-b border-border/60', className)}>
            <div aria-hidden='true' className='pattern-jaali absolute inset-0 text-gold/[0.06]' />
            <div aria-hidden='true' className='absolute -right-40 -top-40 size-[34rem] rounded-full bg-marigold/15 blur-3xl' />
            <div aria-hidden='true' className='toran absolute inset-x-0 top-0' />

            <div className='relative mx-auto max-w-7xl px-5 pb-16 pt-20 sm:px-8 lg:pb-24 lg:pt-28'>
                <p className='inline-flex items-center gap-3 text-xs font-medium uppercase tracking-[0.28em] text-gold'>
                    <span aria-hidden='true' className='h-px w-8 bg-current' />
                    {eyebrow}
                </p>

                <h1 className='mt-5 max-w-4xl text-5xl leading-[1.02] text-foreground sm:text-6xl lg:text-7xl'>
                    {title}
                </h1>

                {description && (
                    <p className='mt-6 max-w-2xl text-lg leading-relaxed text-muted-foreground sm:text-xl'>
                        {description}
                    </p>
                )}

                {children}
            </div>
        </section>
    )
}
